import { PropsWithChildren, ReactNode } from "react";

import { Stack, SxProps, Theme, Typography } from "@mui/material";

interface Props extends PropsWithChildren {
  title: string;
  action?: ReactNode;
  grow?: boolean;
  sx?: SxProps<Theme>;
}

export function ContentCard({ title, action, grow = true, children, sx }: Props) {
  return (
    <Stack
      flex={grow ? 1 : "0 0 auto"}
      p={2}
      gap={3}
      sx={[{ bgcolor: "background.paper" }, ...(sx ? [sx] : [])] as SxProps<Theme>}
    >
      {action ? (
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Typography variant="h6">{title}</Typography>
          {action}
        </Stack>
      ) : (
        <Typography variant="h6">{title}</Typography>
      )}
      {children}
    </Stack>
  );
}
